module.exports = __webpack_public_path__ + "img/9-20.f95a49d2.jpg";